// extracted by mini-css-extract-plugin
module.exports = {"auth":"index_auth_2DPMZ","container":"index_container_1ibPi","googleSign":"index_googleSign_3zxmR","footerNav":"index_footerNav_1TbWe"};